import { useEffect, useState } from "react";
import api from "@/lib/api";
import { fmtDate } from "@/lib/dates";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { CalendarCheck } from "lucide-react";

export const MyAttendance = () => {
  const [attendance, setAttendance] = useState([]);
  useEffect(() => { api.get("/me/attendance").then((r) => setAttendance(r.data || [])).catch(() => {}); }, []);

  return (
    <Card className="bg-white border border-[#E5E0D8] shadow-sm overflow-hidden" data-testid="portal-attendance">
      <div className="flex items-center gap-2 p-5 border-b border-[#E5E0D8]">
        <CalendarCheck className="h-5 w-5 text-[#2D5A27]" />
        <h2 className="font-serif text-xl font-semibold">My Attendance</h2>
        <Badge variant="outline" className="ml-auto bg-[#EAF2E8] text-[#2D5A27] border-[#cfe3cb]" data-testid="portal-attendance-count">{attendance.length} attended</Badge>
      </div>
      <Table>
        <TableHeader>
          <TableRow className="hover:bg-transparent border-[#E5E0D8]"><TableHead>Date</TableHead><TableHead>Gathering</TableHead></TableRow>
        </TableHeader>
        <TableBody>
          {attendance.map((s) => (
            <TableRow key={s.id} className="border-[#E5E0D8]" data-testid={`portal-attendance-${s.id}`}>
              <TableCell className="text-sm text-[#526050]">{fmtDate(s.date)}</TableCell>
              <TableCell className="font-medium text-[#1C241B]">{s.title}<span className="block text-xs text-[#7A8A78]">{s.service_type}</span></TableCell>
            </TableRow>
          ))}
          {attendance.length === 0 && <TableRow><TableCell colSpan={2} className="text-center py-10 text-[#7A8A78]">No attendance recorded yet.</TableCell></TableRow>}
        </TableBody>
      </Table>
    </Card>
  );
};
